import { carouselItems } from '@/mocks/home-data';

export default function CarouselSection() {
  return (
    <section id="carousel" className="py-10 md:py-14 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <h2 className="text-2xl md:text-3xl font-heading text-foreground-950 text-center mb-8">
          焦点专题
        </h2>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-4">
          {carouselItems.map((item) => {
            const tagBg =
              item.tagColor === 'primary'
                ? 'bg-primary-100 text-primary-700'
                : 'bg-accent-100 text-accent-700';
            return (
              <div
                key={item.id}
                className="group bg-background-50 border border-background-200/70 rounded-xl overflow-hidden hover:border-primary-200 transition-all cursor-pointer"
              >
                <div className="relative aspect-[8/5] overflow-hidden">
                  <img
                    src={item.image}
                    alt={item.title}
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                    loading="lazy"
                  />
                  <span
                    className={`absolute top-3 left-3 px-2.5 py-1 rounded-full text-xs font-medium ${tagBg}`}
                  >
                    {item.tag}
                  </span>
                </div>
                <div className="p-4">
                  <h3 className="text-sm font-bold text-foreground-950 mb-1 line-clamp-2">
                    {item.title}
                  </h3>
                  <p className="text-xs text-foreground-500 mb-2">{item.subtitle}</p>
                  <p className="text-xs text-foreground-600 leading-relaxed line-clamp-3">
                    {item.desc}
                  </p>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}